module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publicUserList"
  }, [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('center', [(_vm.publicLoaded == false) ? _c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "relative"
  }, [(_vm.publicLoaded == true) ? _c('v-text-field', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.publicLoaded) ? _c('v-btn', {
    staticClass: "public_user_position dashGenerateRep qtGenerate",
    staticStyle: {
      "background": "#333 !important",
      "color": "#fff !important",
      "height": "30px",
      "position": "absolute !important",
      "top": "auto",
      "margin-top": "-48px",
      "display": "block",
      "right": "2px"
    },
    on: {
      "click": function($event) {
        return _vm.fncFilterUsers()
      }
    }
  }, [_vm._v("SEARCH")]) : _vm._e(), _vm._v(" "), (_vm.publicLoaded) ? _c('v-btn', {
    staticClass: "public_user_position dashGenerateRep qtGenerate",
    staticStyle: {
      "background": "#333 !important",
      "color": "#fff !important",
      "height": "30px",
      "position": "absolute !important",
      "top": "auto",
      "margin-top": "-48px",
      "display": "block",
      "right": "72px"
    },
    on: {
      "click": function($event) {
        return _vm.fncClearSearch()
      }
    }
  }, [_vm._v("CLEAR")]) : _vm._e()], 1)]), _vm._v(" "), _c('v-pagination', {
    attrs: {
      "length": this.publicTotalPages,
      "total-visible": 7
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  }), _vm._v(" "), (_vm.publicLoaded == true) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "id": "hello",
      "items": _vm.filteredUsers,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [2000, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          attrs: {
            "width": "45%"
          }
        }, [_vm._v(_vm._s(props.item.name) + " " + _vm._s(props.item.surname))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.contactnum))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('v-menu', {
          attrs: {
            "offset-y": ""
          }
        }, [_c('v-toolbar-side-icon', {
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditPricelist(props.item.id)
            }
          }
        }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link User Pricelists")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditPassword(props.item.id, props.item.email)
            }
          }
        }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Update Password")]) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditUser(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])])]) : _vm._e()])]
      }
    }], null, false, 2456869480)
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}